// extracted by mini-css-extract-plugin
export default {"mainPageContentWrapper":"main_mainPageContentWrapper__Sm0Uk","skipsCarousel":"main_skipsCarousel__bKH6l","benefitsWrapper":"main_benefitsWrapper__bLdbb"};